/**
 * Enum containing the keys used for invalidating react query
 */
export enum QueryKeys {
  WorkflowCommunications = 'workflow-communications',
  MessagingConversations = 'messaging-conversations',
  MessagingMessages = 'messaging-messages',
  MessagingUnread = 'messaging-unread',
  MessagingRecipients = 'messaging-recipients',
  MessagingSettings = 'messaging-settings',
  Department = 'department',
  Departments = 'departments',
  Designations = 'designations',
  Company = 'company',
  CompanyBilling = 'company-billing',
  BillingAccess = 'billing-access',
  BillingOverview = 'billing-overview',
  BillingInvoices = 'billing-invoices',
  CompanySubscription = 'company-subscription',
  CompanyInvoices = 'company-invoices',
  BillingSettings = 'billing-settings',
  LeaveCyclesHealth = 'leave-cycles-health',
  ScanReports = 'scan-reports',
  ProductMetrics = 'product-metrics',
  ProductMetricsSnapshots = 'product-metrics-snapshots',
  Provinces = 'provinces',
  Branches = 'branches',
  Vendors = 'vendors',
  Companies = 'companies',
  CompanyAdmins = 'companyAdmins',
  LeaveSchedule = 'leaveSchedule',
  LeaveTypes = 'leaveTypes',
  LeaveHolidays = 'leaveHolidays',
  EmployeeSingle = 'employee',
  Employees = 'employees',
  EmployeeLeaveBalances = 'employeeLeaveBalances',
  EmployeeImportJobs = 'employeeImportJobs',
  EmployeeImportJobDetails = 'employeeImportDetails',
  EmployeeImportTemplateValues = 'employeeImportTemplateValues',
  EmployeePortalDocuments = 'employeePortalDocuments',
  EmployeeAssetHistory = 'employeeAssetHistory',
  EmployeeAssignedAssets = 'employeeAssignedAssets',
  EmployeeDocuments = 'employeeDocuments',
  DocumentRequests = 'documentRequests',
  /** The employee portal's own Outlook connection (My calendar). */
  EmployeeCalendarStatus = 'employeeCalendarStatus',
  /** Employee portal: candidates HR shared with me (2026-10-29). */
  CandidateReviews = 'candidateReviews',
  CandidateReviewSummary = 'candidateReviewSummary',
  CandidateReviewResume = 'candidateReviewResume',
  /** The employee's documents to read and confirm (E-signatures). */
  MyAcknowledgements = 'myAcknowledgements',
  MySignatureRequests = 'mySignatureRequests',
  /** The fields I fill in before signing. */
  MySignatureAnswers = 'mySignatureAnswers',
  MySignatureApprovals = 'mySignatureApprovals',
  SignatureGate = 'signatureGate',
  EmployeeEducation = 'employeeEducation',
  EmployeeFamily = 'employeeFamily',
  EmployeeSalary = 'employee-salary',
  CompanyLeaveCalendar = 'company-leave-calendar',
  EmployeeLeaveRequests = 'employeeLeaveRequests',
  EmployeeLeaveBalancesList = 'employeeLeaveBalancesList',
  EmployeeLeavePolicyWallets = 'employee-leave-policy-wallets',
  EmployeeWalletProjection = 'employee-wallet-projection',
  EmployeeLeaveRequestDetail = 'employeeLeaveRequestDetail',
  CompanyLeaveRequests = 'companyLeaveRequests',
  CompanyLeaveSettings = 'company-leave-settings',
  CompanyDocumentTypes = 'companyDocumentTypes',
  EmployeeLeaveTransactions = 'employeeLeaveTransactions',
  EmployeeManagerList = 'employeeManagerList',
  EmployeeAddress = 'employeeAddress',
  EmployeeLeaveManagers = 'employeeLeaveManagers',
  CompanyLeaveRequestById = 'companyLeaveRequestById',
  EmployeeLeaveBalanceById = 'employeeLeaveBalanceById',
  EmployeeAssets = 'employeeAssets',
  Roles = 'roles',
  RolePermissions = 'role-permissions',
  RoleDetails = 'role-details',
  Brands = 'brands',
  LeaveRequestsSummary = 'leaveRequestsSummary',
  LeaveRequestsManagement = 'leaveRequestsManagement',
  /** A request form's day-count preview (server-counted days for its dates). */
  LeaveDayCount = 'leaveDayCount',
  /** Nested under `LeaveRequestsManagement` / `MyTeamApprovals` so a decision refreshes it. */
  LeaveDecisionContext = 'leaveDecisionContext',
  /** Nested under `LeaveRequestsManagement` so a decision refreshes it. */
  NeedsAttention = 'needsAttention',
  EmployeeLeaveWallets = 'employeeLeaveWallets',
  WalletLedger = 'walletLedger',
  CompanyLeaveWallets = 'companyLeaveWallets',
  EmployeeBankDetails = 'employee-bank-details',
  BankAccountFields = 'bank-account-fields',
  Countries = 'countries',
  LinkedBranches = 'linked-branches',
  Admins = 'admins',
  AllocationJobs = 'allocation-jobs',
  CompletedJobEmployees = 'completed-job-employees',
  FiscalYear = 'current-fiscal-year',
  EmployeePermissions = 'employee-permissions',
  EmployeePermissionScopes = 'employee-permission-scopes',
  EmployeeApprovalSettings = 'employee-approval-settings',
  Permissions = 'permissions',
  Folders = 'folders',
  EmployeeFolders = 'employee-folders',
  FolderTree = 'folder-tree',
  EmployeeFolderTree = 'employee-folder-tree',
  Folder = 'folder',
  EmployeeFolder = 'employee-folder',
  Files = 'files',
  EmployeeFiles = 'employee-files',
  File = 'file',
  EmployeeFile = 'employee-file',
  AllFiles = 'all-files',
  EmployeeAllFiles = 'employee-all-files',
  FolderACL = 'folder-acl',
  FileACL = 'file-acl',
  BIN = 'bin',
  FileUpload = 'file-upload',
  Profile = 'profile',
  CompanyAddresses = 'company-addresses',
  EmployeeNotes = 'employee-notes',
  EmployeeNote = 'employee-note',
  EmployeeNoteTags = 'employee-note-tags',
  EmployeeNoteComments = 'employee-note-comments',
  AdminNotes = 'admin-notes',
  AdminNote = 'admin-note',
  AdminNoteCategories = 'admin-note-categories',
  AdminNoteCategory = 'admin-note-category',
  AdminNoteComments = 'admin-note-comments',
  AdminNoteComment = 'admin-note-comment',
  Notes = 'notes',
  Dashboard = 'dashboard',
  BenefitPlanTypes = 'benefitPlanTypes',
  BenefitPlans = 'benefitPlans',
  EmployeeBonuses = 'employeeBonuses',
  EmployeeBonusTypes = 'employeeBonusTypes',
  EmployeeBenefitEnrollments = 'employeeBenefitEnrollments',
  EmployeeCompensationSummary = 'employeeCompensationSummary',
  UserSearch = 'userSearch',
  UserDetail = 'userDetail',
  Announcements = 'announcements',
  Announcement = 'announcement',
  DashboardAnnouncements = 'dashboard-announcements',
  DashboardAnnouncement = 'dashboard-announcement',
  DashboardHolidays = 'dashboard-holidays',
  DashboardOnLeave = 'dashboard-on-leave',
  TasksList = 'tasks-list',
  TaskOccurrences = 'tasks-occurrences',
  TaskOccurrenceDetail = 'tasks-occurrence-detail',
  TaskOccurrenceAssignments = 'tasks-occurrence-assignments',
  TaskOccurrenceSummary = 'tasks-occurrence-summary',
  TaskOccurrenceActivity = 'tasks-occurrence-activity',
  TaskOccurrenceThreads = 'tasks-occurrence-threads',
  TaskAssignmentDetail = 'tasks-assignment-detail',
  TaskThreadDetail = 'tasks-thread-detail',
  TaskThreadMessages = 'tasks-thread-messages',
  EmpMyTasksList = 'emp-my-tasks-list',
  EmpMyTasksDetail = 'emp-my-tasks-detail',
  EmpMyTasksThread = 'emp-my-tasks-thread',
  EmpMyTasksMessages = 'emp-my-tasks-messages',
  EmpMyTasksSummary = 'emp-my-tasks-summary',
  EmpMyTasksActivity = 'emp-my-tasks-activity',
  EmpMgmtSummary = 'emp-mgmt-summary',
  EmpMgmtList = 'emp-mgmt-list',
  EmpMgmtDetail = 'emp-mgmt-detail',
  EmpMgmtMessages = 'emp-mgmt-messages',
  AdminMyTasksList = 'admin-my-tasks-list',
  AdminMyTasksDetail = 'admin-my-tasks-detail',
  AdminMyTasksThread = 'admin-my-tasks-thread',
  AdminMyTasksMessages = 'admin-my-tasks-messages',
  AdminMyTasksSummary = 'admin-my-tasks-summary',
  EmpMgmtActivity = 'emp-mgmt-activity',
  TaskListsList = 'taskListsList',
  AutomationsList = 'automationsList',
  AutomationDetail = 'automationDetail',
  AutomationTriggers = 'automationTriggers',
  AutomationRuns = 'automationRuns',
  AutomationRun = 'automationRun',
  AutomationTaskDetails = 'automationTaskDetails',
  TaskListsDetail = 'taskListsDetail',
  TasksDetail = 'tasksDetail',
  EmployeeFlows = 'employee-flows',
  EmployeeFlow = 'employee-flow',
  EmployeeTask = 'employee-task',
  TaskComments = 'task-comments',
  TaskActivityLogs = 'task-activity-logs',
  AssignedTasksSummary = 'assigned-tasks-summary',
  AssignedTasks = 'assignedTasks',
  AssignedTaskComments = 'assigned-task-comments',
  TimesheetToday = 'timesheet-today',
  TimesheetDay = 'timesheet-day',
  TimesheetHistory = 'timesheet-history',
  TimesheetHoursSummary = 'timesheet-hours-summary',
  TimesheetRequests = 'timesheet-requests',
  TimesheetRequestsCount = 'timesheet-requests-count',
  TimesheetWeekApprovals = 'timesheet-week-approvals',
  TimesheetSettings = 'timesheet-settings',
  MySlackNotificationSettings = 'my-slack-notification-settings',
  SlackStatus = 'slack-status',
  Timezones = 'timezones',
  SurveysList = 'surveys-list',
  SurveysSummary = 'surveys-summary',
  SurveysDetail = 'surveys-detail',
  SurveyAssignmentOptions = 'survey-assignment-options',
  SurveyAssignment = 'survey-assignment',
  SurveyBuilder = 'survey-builder',
  SurveyOverview = 'survey-overview',
  SurveyResponsesList = 'survey-responses-list',
  SurveyResponseDetail = 'survey-response-detail',
  SurveyResults = 'survey-results',
  SurveyTrends = 'survey-trends',
  SurveyTrendForecast = 'survey-trend-forecast',
  SurveyTrendDigest = 'survey-trend-digest',
  SurveyTrendSegments = 'survey-trend-segments',
  SurveyTrendShares = 'survey-trend-shares',
  EmployeeSurveysList = 'employee-surveys-list',
  EmployeeSurveyDetail = 'employee-survey-detail',
  EmployeeSurveyDashboard = 'employee-survey-dashboard',
  ReviewTemplates = 'performance-review-templates',
  ReviewCycles = 'performance-review-cycles',
  ReviewCycleDetail = 'performance-review-cycle-detail',
  ReviewCycleParticipants = 'performance-review-cycle-participants',
  ReviewParticipantDetail = 'performance-review-participant-detail',
  ReviewCycleResults = 'performance-review-cycle-results',
  TeamFeedbackComparison = 'performance-team-feedback-comparison',
  TeamFeedbackResult = 'performance-team-feedback-result',
  TeamFeedbackSettings = 'performance-team-feedback-settings',
  EmployeeTeamFeedback = 'performance-employee-team-feedback',
  MyTeamFeedback = 'performance-my-team-feedback',
  ManagerReviews = 'performance-manager-reviews',
  ManagerReviewDetail = 'performance-manager-review-detail',
  PerformanceColleagues = 'performance-colleagues',
  PerformanceManagers = 'performance-managers',
  PerformanceDepartments = 'performance-departments',
  EmployeeReviewsOverview = 'performance-employee-reviews-overview',
  EmployeeReviewSubmission = 'performance-employee-review-submission',
  EmployeeSharedReview = 'performance-employee-shared-review',
  OneOnOnes = 'performance-one-on-ones',
  OneOnOneDetail = 'performance-one-on-one-detail',
  OneOnOneMeeting = 'performance-one-on-one-meeting',
  OneOnOnePairs = 'performance-one-on-one-pairs',
  OneOnOnePairPeople = 'performance-one-on-one-pair-people',
  PerformanceSummary = 'performance-summary',
  MemberPerformance = 'performance-member',
  MemberSharedReview = 'performance-member-shared-review',
  EmployeeProfilePerformance = 'performance-employee-profile',
  Goals = 'performance-goals',
  GoalDetail = 'performance-goal-detail',
  GoalCheckIns = 'performance-goal-check-ins',
  GoalSettings = 'performance-goal-settings',
  EmployeeGoals = 'performance-employee-goals',
  EmployeeActivityLogs = 'employee-activity-logs',
  CompanyActivityLogs = 'company-activity-logs',
  AdminActivityLogs = 'admin-activity-logs',
  Notifications = 'notifications',
  NotificationsUnreadCount = 'notifications-unread-count',
  AdminMcpConnectionStatus = 'admin-mcp-connection-status',
  EmployeeChangeRequests = 'employee-change-requests',
  EmployeeChangeModes = 'employee-change-modes',
  ChangeRuleSettings = 'change-rule-settings',
  EmployeeChangeRequestsSummary = 'employee-change-requests-summary',
  EmployeeDocumentTypes = 'employee-document-types',
  EmployeeBankCountryFields = 'employee-bank-country-fields',
  PlatformSetting = 'platform-setting',
  AdminDashboardStats = 'admin-dashboard-stats',
  CompanyCategoryCounts = 'company-category-counts',
  ReportingLine = 'reporting-line',
  ReportingLineHistory = 'reporting-line-history',
  ReportingOrgChart = 'reporting-org-chart',
  ReportingSuggestions = 'reporting-suggestions',
  ReportingManagerOptions = 'reporting-manager-options',
  ReportingManagerAccess = 'reporting-manager-access',
  ReportingTemporaryGroups = 'reporting-temporary-groups',
  LeaveRouting = 'leave-routing',
  BackupApprover = 'backup-approver',
  HandoverPreview = 'handover-preview',
  ApprovalSettings = 'approval-settings',
  ApprovalManagerDefaultNotice = 'approval-manager-default-notice',
  ApprovalFallbackOwners = 'approval-fallback-owners',
  ApprovalFallbackCandidates = 'approval-fallback-candidates',
  ApprovalOwnerRequired = 'approval-owner-required',
  TimesheetApprovalSettings = 'timesheet-approval-settings',
  MyTeamTimesheetApprovals = 'my-team-timesheet-approvals',
  MyTeamTimesheetApprovalsCount = 'my-team-timesheet-approvals-count',
  MyTeamAccess = 'my-team-access',
  MyTeamList = 'my-team-list',
  MyTeamSummary = 'my-team-summary',
  MyTeamAttention = 'my-team-attention',
  MyTeamMember = 'my-team-member',
  MyTeamMemberBalances = 'my-team-member-balances',
  MyTeamMemberProbation = 'my-team-member-probation',
  ProbationSettings = 'probation-settings',
  EvaluationPrograms = 'performance-evaluation-programs',
  EvaluationProgram = 'performance-evaluation-program',
  EvaluationProgramEvaluations = 'performance-evaluation-program-evaluations',
  EvaluationProgramTeamRuns = 'performance-evaluation-program-team-runs',
  EvaluationProgramPreview = 'performance-evaluation-program-preview',
  EmployeeUpcomingEvaluations = 'performance-employee-upcoming-evaluations',
  SignalSettings = 'signal-settings',
  NeedsAttentionDigest = 'needs-attention-digest',
  /** `[CompanyWatcherReminderDefault, companyId]`: the company default. */
  CompanyWatcherReminderDefault = 'company-watcher-reminder-default',
  /** `[MyWatcherReminderPreference, ...]`: the signed-in person's own choice. */
  MyWatcherReminderPreference = 'my-watcher-reminder-preference',
  MyTeamMemberLeaveRequests = 'my-team-member-leave-requests',
  MyTeamMemberNotes = 'my-team-member-notes',
  MyTeamMemberNote = 'my-team-member-note',
  MyTeamCalendar = 'my-team-calendar',
  TerminationPreview = 'termination-preview',
  HandoverExceptions = 'handover-exceptions',
  ExceptionsProbationEnding = 'exceptions-probation-ending',
  ExceptionsDocumentsExpiring = 'exceptions-documents-expiring',
  MyTeamApprovals = 'my-team-approvals',
  MyTeamApprovalsCount = 'my-team-approvals-count',
  MyTeamChangeRequests = 'my-team-change-requests',
  MyTeamChangeRequestsCount = 'my-team-change-requests-count',
  MyTeamCovering = 'my-team-covering',
  MyTeamDelegations = 'my-team-delegations',
  MyTeamDelegateCandidates = 'my-team-delegate-candidates',
  TeamOverview = 'team-overview',
  TeamTimeOff = 'team-time-off',
  EmployeeCustomFields = 'employee-custom-fields',
  EmployeeCustomFieldValues = 'employee-custom-field-values',
  EmployeeSin = 'employee-sin',
  MyCustomFields = 'my-custom-fields',
  WorkforceAnalytics = 'workforceAnalytics',
  WorkforceDepartures = 'workforceDepartures',
  LeaveAnalytics = 'leaveAnalytics',
  LeaveAnalyticsRecords = 'leaveAnalyticsRecords',
  RetentionAnalytics = 'retentionAnalytics',
  RetentionHires = 'retentionHires',
  DemographicsAnalytics = 'demographicsAnalytics',
  /** `[MyTrainings, userId, ...]`: the employee's own trainings (PR 2). */
  MyTrainings = 'myTrainings',
}
